import { ClientSetup } from '../../classes/client-setup.interface';

export const wastemanagement_ClientSetup: ClientSetup = {
  splashRoute: '/home',
  loginStyle: 'login-container-wastemanagement',
  loginLogo: '/assets/clients/wastemanagement/Stream-login-logo.png',
  loginLogoStyle: 'img-fluid',
  mapFilter: 'sidebar',
};
